import {
  SpecialistData,
  useSpecialistList,
} from "../../../hooks/react-query/useSpecialistList";
import Image from "next/image";
import Link from "next/link";
import { Fragment, useEffect, useState } from "react";
import { HandWritingH1 } from "../../UI/hand-writing/HandWritingH1";
import { useColors } from "../../../hooks/colors/useColors";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { useTranslation } from "next-i18next";
import { IconArrowNarrowRight } from "@tabler/icons";
import { isPhone } from "../../../constants/env";

type InputProps = {
  authorSlug: string;
};
export function BlogAuthor({ authorSlug }: InputProps) {
  const [specialist, setSpecialist] = useState<SpecialistData | undefined>();
  const { specialists } = useSpecialistList();
  const { colors } = useColors();
  const { i18n } = useTranslation("common");

  useEffect(() => {
    if (specialists && Object.keys(specialists).length > 0) {
      {
        Object.keys(specialists)
            .sort((a, b) => a.localeCompare(b))
            .map((key, index) => {
              if (key === authorSlug) {
                const specialist = specialists[key];
                setSpecialist(specialist);
              }
            });
      }
    }
  }, [authorSlug, specialists]);

  return (
      <Fragment>
        {specialist && (
            <Fragment>
              {isPhone && (
                  <div className="flex justify-center mt-8">
                    <Link
                        href={`/especialistas/${specialist.urlSlug}`}
                        className="hover:cursor-pointer"
                    >
                      <Image
                          className="rounded-xl"
                          alt={specialist.name}
                          src={specialist.image}
                          height={270}
                          width={200}
                          style={{objectFit: 'cover'}}
                      />
                    </Link>
                  </div>
              )}
              <div className="flex gap-8 justify-center mt-8 mb-8">
                {!isPhone && (
                    <Link
                        href={`/especialistas/${specialist.urlSlug}`}
                        className="hover:cursor-pointer"
                    >
                      <Image
                          style={{objectFit: 'cover'}}
                          className="rounded-xl"
                          alt={specialist.name}
                          src={specialist.image}
                          height={270}
                          width={200}
                          // objectFit='cover'
                      />
                    </Link>
                )}
                <div className="flex flex-col justify-center items-center">
                  <HandWritingH1 size={30} className="p-4" color={colors.primary}>
                    {specialist.name}
                  </HandWritingH1>
                  <div className="flex flex-col items-center justify-center">
                    <MyH1 className="text-center font-bold text-2xl p-2">
                      {specialist.description}
                    </MyH1>
                  </div>
                  <Link
                      href={`/blog/autor/${specialist.urlSlug}`}
                      className="hover:cursor-pointer text-center "
                  >
                    <div className="text-center p-4">
                      <div
                          style={{ color: colors.secondary }}
                          className="text-center font-bold text-2xl p-2 hover flex items-center"
                      >
                        <span>{i18n.t("blog.all-entries")}</span>
                        <IconArrowNarrowRight
                            size="2rem"
                            color={colors.secondary}
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </Fragment>
        )}
      </Fragment>
  );
}

// import {
//   SpecialistData,
//   useSpecialistList,
// } from "../../../hooks/react-query/useSpecialistList";
// import Image from "next/image";
// import Link from "next/link";
// import { Fragment, useEffect, useState } from "react";
// import { useColors } from "../../../hooks/colors/useColors";
// import { useTranslation } from "next-i18next";
// import { IconArrowNarrowRight } from "@tabler/icons";
// import { isPhone } from "../../../constants/env";
// import { HandWritingH2 } from "../../UI/hand-writing/HandWritingH2";
// import { Post } from "../../../types/graphql";
//
// type InputProps = {
//   blog: Post;
// };
// export function BlogAuthor({ blog }: InputProps) {
//   const [specialist, setSpecialist] = useState<SpecialistData | undefined>();
//   const { specialists } = useSpecialistList();
//   const { colors } = useColors();
//   const { i18n } = useTranslation("common");
//
//   useEffect(() => {
//     if (specialists && Object.keys(specialists).length > 0) {
//       {
//         Object.keys(specialists)
//           .sort((a, b) => a.localeCompare(b))
//           .map((key, index) => {
//             if (
//               typeof blog.author?.node.name !== "undefined" &&
//               key
//                 .replaceAll("-", "")
//                 .includes(
//                   blog.author?.node.slug!.toString().replaceAll("-", "")
//                 )
//             ) {
//               const specialist = specialists[key];
//               setSpecialist(specialist);
//             }
//           });
//       }
//     }
//   }, [blog, specialists]);
//
//   return (
//     <Fragment>
//       {blog.author && blog.author.node && (
//         <Fragment>
//           {isPhone && (
//             <div className="flex justify-center mt-8">
//               <Link
//                 href={`/especialistas/${blog.author.node.slug}`}
//                 className="hover:cursor-pointer"
//               >
//                 <Image
//                   className="rounded-xl"
//                   alt={blog.author.node.name || "author"}
//                   // @ts-ignore
//                   src={blog.author?.node.avatar?.url}
//                   height={270}
//                   width={200}
//                   objectFit="cover"
//                 />
//               </Link>
//             </div>
//           )}
//           <div className="flex gap-8 justify-center mt-8 mb-8">
//             {!isPhone && (
//               <Link
//                 href={`/especialistas/${blog.author.node.slug}`}
//                 className="hover:cursor-pointer"
//               >
//                 <Image
//                   className="rounded-xl"
//                   alt={blog.author.node.name || "author"}
//                   // @ts-ignore
//                   src={blog.author?.node.avatar?.url}
//                   height={270}
//                   width={200}
//                   objectFit="cover"
//                 />
//               </Link>
//             )}
//             <div className="flex flex-col justify-center items-center">
//               {specialist && (
//                 <Link
//                   href={`/especialistas/${specialist.urlSlug}`}
//                   className="hover:cursor-pointer flex items-center"
//                 >
//                   <HandWritingH2
//                     size={30}
//                     className="p-4"
//                     color={colors.primary}
//                   >
//                     {blog.author.node.name}
//                   </HandWritingH2>
//                   <IconArrowNarrowRight size="2rem" color={colors.primary} />
//                 </Link>
//               )}
//               {!specialist && (
//                 <HandWritingH2 size={30} className="p-4" color={colors.primary}>
//                   {blog.author.node.name}
//                 </HandWritingH2>
//               )}
//               {/*<div className="flex flex-col items-center justify-center">*/}
//               {/*  <h3 className="text-center font-bold text-2xl p-2">*/}
//               {/*    {specialist.description}*/}
//               {/*  </h3>*/}
//               {/*</div>*/}
//               <Link
//                 href={`/blog/autor/${blog.author.node.slug}`}
//                 className="hover:cursor-pointer text-center "
//               >
//                 <div className="text-center p-4">
//                   <div
//                     style={{ color: colors.secondary }}
//                     className="text-center font-bold text-2xl p-2 hover flex items-center"
//                   >
//                     <span>{i18n.t("blog.all-entries")}</span>
//                     <IconArrowNarrowRight
//                       size="2rem"
//                       color={colors.secondary}
//                     />
//                   </div>
//                 </div>
//               </Link>
//             </div>
//           </div>
//         </Fragment>
//       )}
//     </Fragment>
//   );
// }
